import { css } from '@linaria/core';
import theme from '../../../theme';
import { card } from '../card/card.styles';

export const components = {
  overlay: css``,
  close: css``,
};

export const variants = {
  open: css``,
};

export const modal = css`
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 99;
  overflow-y: auto;
  overflow-x: hidden;
  visibility: hidden;
  opacity: 0;
  transition:
    opacity 0.3s,
    visibility 0.3s;

  &.${variants.open} {
    opacity: 1;
    visibility: visible;
  }

  & .${components.overlay} {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1;
    align-self: start;

    // Previously we didn't use before and use position: fixed but it was causing issues with the scroll
    // This way we can preserve both proper scroll and backdrop click functionality.
    &::before {
      background: rgba(0, 0, 0, 0.3);
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      display: block;
      width: 100vw;
      height: 100vh;
    }
  }

  & .${card} {
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.05);
    padding: 1rem;
    max-height: 95vh;
    max-width: 90vw;
    overflow-y: auto;
    overflow-x: hidden;
    @media screen and (width > ${theme.sizes.screens.md}) {
      padding: 3rem;
    }
    border-radius: 16px;
    z-index: 2;
    position: relative;
    margin: auto;
  }

  & .${components.close} {
    width: fit-content;
    height: fit-content;
    line-height: 1;
    font-size: 24px;
    outline-offset: 0;
    color: ${theme.colors.neutral['3']};
    position: absolute;
    top: 1rem;
    right: 1rem;
    cursor: pointer;
    z-index: 10;
    &:hover {
      color: ${theme.colors.neutral['50']};
    }
  }
`;
